export const SkillValidation = (values) => {
    let errors = {};

    if (!values?.name?.trim()) {
        errors.name = "Enter skill name";
    }

    if (!values?.skill_image) {
        errors.skill_image = "Enter skill image";
    }
    if (!values?.title?.trim()) {
        errors.title = "Enter title";
    }
    if (!values?.activityType) {
        errors.activityType = 'Activity Type is required'
    }

    if (values?.categoryId === null) {
        errors.categoryId = 'Category is required'
    }

    return errors;
};